import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { NotificationService } from "../../services/notification.service";
import { ApiUserService } from "../../services/user.service";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";

let Profile = {
    selector: "vcProfile",
    templateUrl: "/angular/components/profile/profile.component.html",
    bindings: {
        user: "=",
        changeLiveCampaign: "&",
    },
    controller: class ProfileController {
        // * bindings for typescript compiler *
        public user: User;
        public changeLiveCampaign: Function;
        // ************************************

        public selectedCampaign: Campaign;
        public edit_campaign: Campaign | undefined = undefined;
        public selectedOrganisation?: Organisation;
        public edit_organisation?: Organisation;
        public oauth2Api = {};
        public campaigns: Campaign[] = [];
        public userOwnerCampaigns: Campaign[] = [];
        public allCampaigns: Campaign[] = [];
        public notificationSettings: any = null;
        public emailChange = false;
        public loading = true;
        public organisationOwner = false;

        private $scope: any;
        private $window: any;
        private $cookies: any;
        public __env: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        private apiUserService: ApiUserService;
        private notificationService: NotificationService;
        private campaignDataProvider: CampaignDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        public permissionProvider: PermissionCheck;

        public cancelAccountText: string;

        constructor(
            $scope: any,
            $window: any,
            $cookies: any,
            __env: any,
            ApiUserService: ApiUserService,
            UserDataProvider: UserDataProvider,
            NotificationService: NotificationService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            CampaignDataProvider: CampaignDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.$cookies = $cookies;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.apiUserService = ApiUserService;
            this.notificationService = NotificationService;
            this.campaignDataProvider = CampaignDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.permissionProvider = PermissionCheck;

            this.notificationService.settings().then((response: object) => {
                const json = response["data"];

                if (json["success"]) {
                    this.notificationSettings = json["data"];
                }
            });

            UserDataProvider.getUser(this.$cookies.get("uid")).then(
                (user: User) => {
                    this.emailChange =
                        user.email_confirmation.pendingemail != null &&
                        user.email_confirmation.pendingemail != user.uemail;
                    this.user.preferences = user.preferences ?? {};
                }
            );
        }

        $onInit() {
            setTimeout(() => {
                if (this.user.permissionid == 8) {
                    this.organisationOwner = true;
                }
            }, 1000);

            this.campaignDataProvider
                .allCampaigns()
                .then((campaigns: Campaign[]) => {
                    this.campaigns = campaigns;
                    this.loading = false;
                    let essentialsAvailable = false;

                    this.campaigns.forEach((campaign: Campaign) => {
                        if (campaign.campaignowner == this.user.uid) {
                            this.userOwnerCampaigns.push(campaign);

                            if (
                                campaign.essentialsModeAvailable(this.user.uid)
                            ) {
                                essentialsAvailable = true;
                            }
                        }
                    });

                    if (this.userOwnerCampaigns.length > 0) {
                        this.cancelAccountText = essentialsAvailable
                            ? "Cancel or Pause Subscription"
                            : "Cancel Subscription";
                    } else {
                        this.cancelAccountText = "Delete my profile";
                    }
                });
            this.user.getCard();
        }

        openCampaignPage(campaign: Campaign): void {
            if (!campaign || !campaign.campaignid) {
                return;
            }
            const redirect = "/#/campaign/" + campaign.campaignid;
            this.campaignDataProvider.changeLiveCampaign(campaign).then(
                () => {
                    this.$window.location = redirect;
                    setTimeout(() => {
                        this.$window.location.reload();
                    }, 500);
                },
                () => {
                    this.toast.error();
                }
            );
        }

        setSelectedOrganisation(organisation: Organisation): void {
            this.selectedOrganisation = organisation;
            this.edit_organisation = _.cloneDeep(this.selectedOrganisation);
        }

        setSelectedCampaign(campaign: Campaign): void {
            this.selectedCampaign = campaign;
            this.edit_campaign = _.cloneDeep(this.selectedCampaign);
        }

        updateNotificationSettings(): void {
            this.notificationService
                .updateSettings(this.notificationSettings)
                .then((response: object) => {
                    const json = response["data"];

                    if (json["success"]) {
                        this.toast.success("Notification Updated");
                    } else {
                        this.toast.error();
                    }
                });
        }

        openCreditCardModal($event: any): void {
            this.subscriptionDataProvider
                .setupIntentUpgrade()
                .then((intent: any) => {
                    let parentEl = angular.element(document.body);
                    this.dialog.show({
                        parent: parentEl,
                        component: "vc-create-credit-card-modal",
                        targetEvent: $event,
                        scope: this.$scope,
                        locals: {
                            user: this.user,
                            plan: { intent: intent },
                            charge: false,
                        },
                        ariaLabel: "Update Card",
                    });
                });
        }

        update24hrPreference(): void {
            if (!this.user.preferences) {
                this.user.preferences = {};
            }
            this.user.preferences["24hrTime"] =
                !!this.user.preferences["24hrTime"];
            this.apiUserService.update(this.user).then((response: object) => {
                let json = response["data"];
                if (json.success) {
                    this.$cookies.put(
                        "24hrTime",
                        this.user.preferences["24hrTime"] ? "1" : "0",
                        {
                            domain: "." + this.__env.host,
                            path: "/",
                        }
                    );
                    this.toast.success("Profile Updated");
                } else {
                    this.toast.error();
                }
            });
        }

        openUpdateUserProfile($event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog
                .show({
                    parent: parentEl,
                    component: "vc-edit-profile",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {
                        user: this.user,
                    },
                    ariaLabel: "Change Account Settings",
                })
                .then((user: User) => {
                    angular.extend(this.user, user);
                    this.emailChange = this.user.uemail != user.pendingemail;
                    if (this.emailChange) {
                        this.user.email_confirmation.pendingemail =
                            user.pendingemail;
                    }
                });
        }

        openChangePassword(user: User, $event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog.show({
                parent: parentEl,
                component: "vc-change-password-dialog",
                targetEvent: $event,
                scope: this.$scope,
                locals: {
                    user: user,
                },
                ariaLabel: "Change Password",
            });
        }

        openDeleteAccountDialog(ev: any): void {
            if (this.organisationOwner) {
                const alertDialog = this.dialog
                    .alert()
                    .textContent(
                        `Please contact ${this.__env.support_email} to get your account deleted.`
                    )
                    .targetEvent(ev)
                    .ok("OK");
                this.dialog.showPreConfiguredDialog(alertDialog);
            } else {
                if (this.userOwnerCampaigns.length > 0) {
                    this.$window.location = "/#/cancel";
                } else {
                    this.dialog
                        .delete({
                            targetEvent: ev,
                            skipHide: true,
                            fullscreen: true,
                            locals: {
                                title: `Delete Profile?`,
                                bodyText: `You're about to permanently delete your account. You will no longer be able to log in to any Ecanvasser account. This action cannot be undone.`,
                            },
                        })
                        .then(() => {
                            this.apiUserService
                                .remove({
                                    id: this.user.uid,
                                })
                                .then((response: object) => {
                                    let json = response["data"];
                                    if (json.success) {
                                        this.$window.location =
                                            "/goodbye.php?email=" +
                                            encodeURIComponent(
                                                this.user.uemail
                                            ) +
                                            "&uid=" +
                                            this.user.uid;
                                    } else {
                                        this.loading = false;
                                        this.toast.error(
                                            "Something went wrong"
                                        );
                                    }
                                });
                        });
                }
            }
        }

        changePhoto($event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog.show({
                parent: parentEl,
                component: "vc-image-crop-dialog",
                targetEvent: $event,
                scope: this.$scope,
                locals: {},
                ariaLabel: "Image Crop",
                size: "auto",
            });
        }
    },
};

angular.module("profile").component(Profile.selector, Profile);
